import { useQuery } from '@tanstack/react-query';
import { ChevronRight } from 'lucide-react';
import { Badge, Card } from '@/components/ui';
import { api } from '@/lib/api';
import { useDetail } from '@/lib/hooks';

/** Data quality suggestions (PRD 6.1). Suggestions only; nothing is blocked. */
export function HealthPanel({ compact }: { compact?: boolean }) {
  const { data } = useQuery({ queryKey: ['health'], queryFn: api.dataHealth });
  const { open } = useDetail();
  if (!data) return null;
  const checks = data.checks.filter((c) => c.items.length);
  return (
    <Card className="p-4">
      <div className="mb-2 flex items-center justify-between">
        <h2 className="font-semibold">Health check</h2>
        <Badge tone={data.total ? 'warn' : 'ok'}>
          {data.total ? `${data.total} suggestions` : 'all good'}
        </Badge>
      </div>
      {checks.length === 0 && <div className="text-sm text-muted-fg">No issues found.</div>}
      <div className="space-y-1">
        {checks.map((c) => (
          <details key={c.key} open={!compact && c.items.length <= 3} className="group">
            <summary className="flex cursor-pointer list-none items-center gap-1 text-sm">
              <ChevronRight size={13} className="transition-transform group-open:rotate-90" />
              <span className="font-medium">{c.label}</span>
              <Badge>{c.items.length}</Badge>
            </summary>
            <div className="ml-5 mt-1 text-xs text-muted-fg">{c.suggestion}</div>
            <ul className="ml-5 mt-1 space-y-0.5 text-sm">
              {c.items.map((i) => (
                <li key={i.id}>
                  <button className="text-left hover:underline" onClick={() => open(i.id)}>
                    {i.title}
                  </button>
                  {i.detail && <span className="ml-1 text-xs text-muted-fg">{i.detail}</span>}
                </li>
              ))}
            </ul>
          </details>
        ))}
      </div>
    </Card>
  );
}
